/* eslint-disable jsx-a11y/anchor-has-content */
import React from 'react'
import { connect } from 'react-redux'
import _ from 'lodash'
import moment from 'moment'
import { Button } from 'semantic-ui-react'

import firebase from '../../../config/firebase'

import MerchantSettlementActions from '../../../reducers/merchantSettlementReducer'

const HEADER = ['No', 'Name', 'ABA Name', 'ABA Number', 'Order Count', 'Amount', 'Paid Date', 'Status']

class MerchantSettlementDownloadButton extends React.Component {
  fileReader = new FileReader()
  fileInputRef = React.createRef()
  downloadLinkRef = React.createRef()

  state = {
    downloading: false,
    downloadUrl: '',
  }

  onDownloadClick = async () => {
    const { loaded, syncMerchantSettlements } = this.props

    if (!loaded) {
      syncMerchantSettlements()
    } else {
      const { merchantSettlements, merchantSettlementId } = this.props

      const arrangedData = this.arrangeData(merchantSettlements[merchantSettlementId].restaurants)
      const csvString = this.generateCSV(arrangedData)

      const snapshot = await this.uploadFile(csvString)
      this.downloadFile(snapshot)
    }
  }

  onClearFile = () => {
    this.fileReader.abort()
    this.fileInputRef.value = ''
  }

  arrangeData = data => {
    const branchRows = []

    let i = 0
    _.each(data, rest => {
      _.each(rest.branches, branch => {
        const paidDate = branch.paid_at ? moment(Number(branch.paid_at)).format('DD-MMM-YYYY HH:mm a') : ''
        const abaName = branch.aba_account_name ? branch.aba_account_name.trim() : '--'
        const abaNumber = branch.aba_account_number ? branch.aba_account_number.trim() : '--'
        const totalAmount = Number(parseFloat(branch.total_amount).toFixed(2))
        const isPaid = branch.status === 'paid' ? 'PAID' : 'NOT PAID'
        const row = [
          i + 1,
          `${rest.name} - ${branch.name}`,
          `"=""${abaNumber}"""`,
          `"=""${abaName}"""`,
          branch.order_count,
          `$ ${totalAmount}`,
          paidDate,
          isPaid,
        ]
        branchRows.push(row)
      })
    })

    return branchRows
  }

  generateCSV = data => {
    let csvString = ''

    csvString = csvString.concat(`${HEADER.join(', ')} \n`)
    csvString = csvString.concat(`${data.join('\n')} \n`)

    return csvString
  }

  onReadFile = () => {
    const self = this

    this.fileReader.onload = event => {
      const dataFromJSON = JSON.parse(event.target.result)
      self.props.getOrderByDateSuccess(dataFromJSON)
      self.onClearFile()
    }

    this.fileReader.onloadstart = () => {
      self.setState({ uploading: true })
    }
    this.fileReader.onloadend = () => {
      self.setState({ uploading: false })
    }
  }

  onFileChange = e => {
    const file = e.target.files[0]

    if (file) {
      this.onReadFile()
      this.fileReader.readAsText(file)
    }
  }

  uploadFile = async csvString => {
    const { filename } = this.props
    const storage = firebase
      .storage()
      .ref()
      .child(`report/${filename}.csv`)

    this.setState({ downloading: true })

    return storage.putString(csvString.toString())
  }

  downloadFile = snapshot => {
    const self = this
    snapshot.ref.getDownloadURL().then(downloadUrl => {
      self.setState({ downloading: false, downloadUrl }, () => {
        self.downloadLinkRef.click()
      })
    })
  }

  render() {
    const { downloading, downloadUrl } = this.state
    // const { orders, loading } = this.props

    return (
      <div style={{ display: 'inline' }}>
        <Button
          size="mini"
          // disabled={downloading || loading || _.size(orders) === 0}
          loading={downloading}
          onClick={this.onDownloadClick}
        >
          Download
        </Button>
        <a
          href={downloadUrl}
          ref={ref => {
            this.downloadLinkRef = ref
          }}
          style={{ display: 'none' }}
        />
        <input
          type="file"
          accept=".csv"
          hidden
          ref={ref => {
            this.fileInputRef = ref
          }}
          onChange={this.onFileChange}
        />
      </div>
    )
  }
}

const mapState = ({ merchantSettlements }) => ({
  loaded: merchantSettlements.loaded,
  loading: merchantSettlements.loading,
  merchantSettlements: merchantSettlements.data,
})

const mapDispatch = {
  syncMerchantSettlements: MerchantSettlementActions.syncMerchantSettlements,
}

export default connect(
  mapState,
  mapDispatch
)(MerchantSettlementDownloadButton)



// WEBPACK FOOTER //
// ./src/containers/merchantSettlement/component/Download.js